"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentType = void 0;
var SegmentType;
(function (SegmentType) {
    SegmentType["HH"] = "household";
    SegmentType["SOHO"] = "small_office_home_office";
    SegmentType["SME"] = "small_medium_enterprise";
    SegmentType["SPEC"] = "special";
    SegmentType["RENT"] = "rentals";
})(SegmentType = exports.SegmentType || (exports.SegmentType = {}));
